import { baseApi } from "../baseApi";

export const appointmentsApi = baseApi
  .enhanceEndpoints({ addTagTypes: ["Appointments"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAppointments: builder.query({
        query: (payload) => ({
          url: "/v3/appointments/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["Appointments"],
      }),

      createAppointment: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/create",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),

      createBulkAppointments: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/create-bulk",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),

      rescheduleAppointment: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/reschedule",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),

      cancelAppointment: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/cancel",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),

      confirmAppointment: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/confirm",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),

      updateAppointment: builder.mutation({
        query: (payload) => ({
          url: "/v3/appointments/edit",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["Appointments"],
      }),
    }),
  });

export const {
  useGetAppointmentsQuery,
  useLazyGetAppointmentsQuery,
  useCreateAppointmentMutation,
  useCreateBulkAppointmentsMutation,
  useRescheduleAppointmentMutation,
  useCancelAppointmentMutation,
  useConfirmAppointmentMutation,
  useUpdateAppointmentMutation,
} = appointmentsApi;
